import { tKey, type I18nKey } from "@/core/i18n";
import { z } from "zod";

/** The catalog key of the problem with a typed address, or null when it is fine. */
export const validateCameraApiUrl = (
  value: string | null | undefined,
): I18nKey<"project"> | null => {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return null;
  const result = z.url().safeParse(trimmed);
  return result.success ? null : tKey("project:details.invalidUrl");
};
